import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { DEFAULT_CLASSES, sortClasses, minOfClasses } from "../../lib/classes";
import * as m from "../../lib/model";
import { MoneyInput } from "../shared";

export function ClassEditor({ value, onChange, basePref }) {
  const on = Array.isArray(value) && value.length > 0;
  const set = (i, k, v) => onChange(value.map((c, j) => (j === i ? { ...c, [k]: v } : c)));
  const remove = (i) => onChange(value.filter((_, j) => j !== i));
  const add = () => onChange([...value, { name: String.fromCharCode(65 + value.length), min: 0, pref: basePref || 8, perk: "" }]);
  const sorted = sortClasses(value);
  return (
    <div data-testid="class-editor">
      <label className="cim-sec-row" data-testid="share-classes-row">
        <input type="checkbox" checked={on} onChange={() => onChange(on ? [] : DEFAULT_CLASSES.map((c) => ({ ...c })))} data-testid="share-classes-toggle" />
        <span style={{ flex: 1 }}>
          <span style={{ fontSize: 13 }}>Investment classes by amount</span>
          <span style={{ display: "block", fontSize: 10.5, color: "var(--text3)" }}>Tier the preferred return by commitment size. The lowest tier sets the minimum commitment.</span>
        </span>
      </label>
      {on && (
        <>
          <table className="tbl cls-edit" data-testid="class-table">
            <thead><tr><th>Class</th><th>Min commitment ($)</th><th>Pref return %</th><th>Perk (optional)</th><th /></tr></thead>
            <tbody>
              {value.map((c, i) => (
                <tr key={i} data-testid={`class-row-${i}`}>
                  <td><input className="inp" value={c.name} maxLength={12} onChange={(e) => set(i, "name", e.target.value)} data-testid={`class-name-${i}`} /></td>
                  <td><MoneyInput value={c.min} onChange={(v) => set(i, "min", +v || 0)} testid={`class-min-${i}`} /></td>
                  <td><input className="inp mono" type="number" step={0.5} value={c.pref} onChange={(e) => set(i, "pref", +e.target.value)} data-testid={`class-pref-${i}`} /></td>
                  <td><input className="inp" value={c.perk || ""} placeholder="e.g. advisory board seat" onChange={(e) => set(i, "perk", e.target.value)} data-testid={`class-perk-${i}`} /></td>
                  <td><button className="icon-btn" onClick={() => remove(i)} title="Remove class" data-testid={`class-del-${i}`}><Trash2 size={11} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="cls-foot">
            <button type="button" className="link-btn lime" onClick={add} data-testid="class-add"><Plus size={11} /> Add class</button>
            <span className="ra-sub" data-testid="class-summary">
              {sorted.map((c) => `Class ${c.name} ${m.fmt$(c.min)}+ · ${c.pref}%`).join("  |  ")} — minimum commitment {m.fmt$(minOfClasses(value))}
            </span>
          </div>
        </>
      )}
    </div>
  );
}
